function applyBetChanges(
  selections: PlaceBetSportSelection[],
  betChanges: BetChange[],
): PlaceBetSportSelection[] {
  return selections.map((sel) => {
    const betChange = betChanges.find(
      (bc) =>
        bc.selections.includes(sel.eventId) &&
        bc.betTypeId === sel.betTypeId &&
        bc.oddName === sel.oddName,
    );
    return betChange ? { ...sel, oddPrice: betChange.newPrice } : sel;
  });
}

function applyRowChanges(
  rows: PlaceBetSportRow[],
  selections: PlaceBetSportSelection[],
  rowChanges: RowChange[],
): PlaceBetSportRow[] {
  return rows.map((row) => {
    const rowEventIds = row.selectionKeys
      .map((key) => selections.find((s) => s.key === key)?.eventId)
      .filter((id): id is number => id != null)
      .sort((a, b) => a - b);
    const rowChange = rowChanges.find(
      (rc) =>
        rc.selections.length === rowEventIds.length &&
        [...rc.selections]
          .sort((a, b) => a - b)
          .every((id, i) => id === rowEventIds[i]),
    );
    return rowChange ? { ...row, amount: rowChange.newAmount } : row;
  });
}

export function applyAuthorizationChanges(
  request: PlaceBetSportPayload,
  message: AuthorizationMessage,
): PlaceBetSportPayload {
  // Use ?? instead of destructuring defaults so null is also treated as empty.
  const betChanges = message.betChanges ?? [];
  const rowChanges = message.rowChanges ?? [];
  if (betChanges.length === 0 && rowChanges.length === 0) return request;

  const selections = applyBetChanges(request.selections, betChanges);
  const rows = applyRowChanges(request.rows, request.selections, rowChanges);
  const totalStake = rows.reduce((sum, r) => sum + r.amount, 0);

  return { ...request, selections, rows, totalStake };
}
